import { createContext, ReactNode, useContext } from "react";

interface MobileNavigationContextValue {
  openNavigation: () => void;
  title: string | null;
  setActions: (actions: ReactNode) => void;
  setTitle: (title: string | null) => void;
}

const MobileNavigationContext =
  createContext<MobileNavigationContextValue | null>(null);

export const MobileNavigationProvider = MobileNavigationContext.Provider;

export const useMobileNavigation = () => useContext(MobileNavigationContext);
